import { EnvironmentProviders, APP_INITIALIZER, makeEnvironmentProviders } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { AuthService } from './auth.service';

export function initAuth(authService: AuthService): () => Promise<void> | void {
  return () => {
    console.log('[Auth] Initialization complete');
  };
}

export function provideAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    // Provide HttpClient and allow interceptors to come from the DI container
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthService],
      multi: true
    }
  ]);
}